// TalentTour.jsx

import React from "react";
import "./TourPages.css";
import Footer from "../../components/NonLoggedFooter";

import TalentHero from "../../assets/talent-tour.jpg";
import Navigation from "../../RootNavigation";

export default function TalentTour() {
  return (
    <>
    <Navigation />
      <section className="tour-hero">
        <img
          src={TalentHero}
          alt="Talent Tour"
          className="tour-hero-image"
        />

        <div className="tour-hero-overlay">
          <h1>Talent Tour</h1>
        </div>
      </section>

      <section className="tour-container">

        <p>
          For over 26 years, DirectSubmit has connected thousands of performers
          with legitimate casting professionals nationwide.
        </p>

        <p>
          We provide a professional platform where actors, models, dancers,
          singers, and voice-over artists submit directly to casting calls for
          film, television, commercials, print, theatre, and live productions.
        </p>

        <p className="tour-highlight">
          DirectSubmit is where serious on-camera talent books professional work
          and gets paid.
        </p>

        <h3>Create Your Professional Profile</h3>

        <p>
          Your profile is your digital calling card. Upload headshots, reels,
          résumés, special skills, and media that represent you at your best.
        </p>

        <h3>Your Profile Includes:</h3>

        <ul>
          <li>Multiple Headshots</li>
          <li>Résumé & Credits</li>
          <li>Special Skills & Training</li>
          <li>Demo Reels & Audio Clips</li>
          <li>Contact & Representation Info</li>
        </ul>

        <h3>Browse & Submit to Casting Calls</h3>

        <p>
          Search casting notices by location, role type, production category,
          and compensation.
        </p>

        <h3>You’re in Control:</h3>

        <ul>
          <li>Submit to roles that match your look and skills</li>
          <li>Send self-tapes to projects casting across the U.S.</li>
          <li>Receive casting alerts when roles match your type</li>
        </ul>

        <h3>Be Discovered by Casting Directors</h3>

        <p>
          Casting professionals use DirectSubmit to find new talent every day.
          A complete profile allows industry decision-makers to discover you
          even before you submit.
        </p>

        <h3>Direct. Submit. Booked.</h3>

        <p>
          Your next opportunity could be one click away. Start today with a
          free trial and begin submitting immediately.
        </p>
      </section>

      <Footer />
    </>
  );
}